/**
 * Whether the Pro sales offering is available in this web build.
 *
 * Vite exposes environment variables as strings, so only the exact string
 * "true" enables the offering. Missing, false, and any other value remain off.
 */
export function isProOfferingEnabled(value: unknown): boolean {
  return value === "true";
}

/**
 * Round 26: off in every build, whatever VITE_PRO_OFFERING_ENABLED says.
 * Pro was withdrawn on 2026-10-18 pending a real implementation (its
 * "Priority Boost" had nothing behind it). Dormant, not dead code: kept so it can
 * be built properly later — do not delete.
 * This one switch hides every Pro surface: the upgrade modal, the
 * /pro-dashboard route and the "Pro Seller" badges. To bring Pro back, set it
 * to isProOfferingEnabled(import.meta.env.VITE_PRO_OFFERING_ENABLED) again.
 */
export const PRO_OFFERING_ENABLED: boolean = false;